import { useState, useCallback, useMemo, useEffect } from "react";
import { useKeycloakQueries, useAuth } from "@inbody/keycloak";
const useUserSearch = () => {
  const { useFetchUserList } = useKeycloakQueries();
  const { corporateCode } = useAuth();
  const { data: fetchedUserList = [] } = useFetchUserList(corporateCode);
  const [query, setQuery] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const onClearQuery = useCallback(() => {
    setQuery("");
  }, []);
  const onSelectUser = useCallback((id) => {
    setSelectedUserId(id);
  }, []);
  const filteredUserList = useMemo(() => {
    if (!query.trim()) {
      return [];
    }
    const searchTerm = query.toLowerCase().trim();
    const searchTermWithoutHyphen = searchTerm.replace(/-/g, "");
    return fetchedUserList.filter((user) => {
      var _a, _b, _c, _d, _e;
      const name = ((_a = user.preferredName) == null ? void 0 : _a.toLowerCase()) || "";
      const email = ((_b = user.email) == null ? void 0 : _b.toLowerCase()) || "";
      const group = ((_c = user.leafGroupPath) == null ? void 0 : _c.toLowerCase()) || "";
      const workAssignment = ((_d = user.workAssignment) == null ? void 0 : _d.toLowerCase()) || "";
      const phoneNumber = ((_e = user.phoneNumber) == null ? void 0 : _e.toLowerCase().replace(/-/g, "")) || "";
      return name.includes(searchTerm) || email.includes(searchTerm) || group.includes(searchTerm) || workAssignment.includes(searchTerm) || phoneNumber.includes(searchTermWithoutHyphen);
    }).sort(
      (a, b) => (a.preferredName || "").localeCompare(b.preferredName || "", "ko")
    );
  }, [query, fetchedUserList]);
  useEffect(() => {
    var _a;
    setSelectedUserId(((_a = filteredUserList[0]) == null ? void 0 : _a.id) ?? null);
  }, [filteredUserList]);
  const selectedUser = useMemo(
    () => fetchedUserList.find((user) => user.id === selectedUserId) ?? null,
    [fetchedUserList, selectedUserId]
  );
  return {
    query,
    setQuery,
    onClearQuery,
    filteredUserList,
    selectedUserId,
    selectedUser,
    onSelectUser
  };
};
export {
  useUserSearch
};
